import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { BriefSection } from '../../../../types';
import { containerPaddingXBySmBreakpoint } from '../../../common/containerStylePaddingX.ve.css';
import { responsiveDisplay } from '../../util';
import { ExcludedSectionsList } from '../ExcludedSectionsList';
import { disabledBriefEditorOpacity } from '../../../../common/constants';

interface ExcludedSectionsSidebarProps {
  sections: BriefSection[];
  disabled?: boolean;
}

export const ExcludedSectionsSidebar = ({ sections, disabled }: ExcludedSectionsSidebarProps) => (
  <Container
    className={containerPaddingXBySmBreakpoint}
    display={responsiveDisplay('flex', true)}
    direction="row"
    gap="8"
    maxWidth="298px"
    marginRight="8"
  >
    <Stack
      direction="column"
      paddingY="8"
      width={268}
      gap="4"
      flexShrink={0}
      overflowX="visible"
      style={{
        opacity: disabled ? disabledBriefEditorOpacity : '1',
      }}
      pointerEvents={disabled ? 'none' : undefined}
    >
      <ExcludedSectionsList sections={sections} />
    </Stack>
  </Container>
);
